import React from "react";

// Import new components
import FunnelBuilder from "./components/FunnelBuilder";
import ErrorBoundary from "./components/ErrorBoundary/ErrorBoundary";
import { AddFunnelSteps } from "../../AddEditLandingPage.types";

const FunnelStep = ({
    onSave,
    form,
    selectedTemplatedID,

    templates,

    customSources,
    isLandingPageFormLoading,
    selectedCustomSourceId,
}) => {
    const onSubmit = (data) => {
        onSave({
            stepName: AddFunnelSteps.FUNNEL,
            data,
        });
    };
    return (
        <ErrorBoundary>
            <FunnelBuilder
                onSave={onSubmit}
                form={form}
                selectedTemplatedID={selectedTemplatedID}
                templates={templates}
                customSources={customSources}
                selectedCustomSourceId={selectedCustomSourceId}
                isLandingPageFormLoading={isLandingPageFormLoading}
            />
        </ErrorBoundary>
    );
};

export default FunnelStep;
